export default {
    en: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "THE MESSAGE",
                    id: "nav-message"
                },
                {
                    name: "EXPERIENCE",
                    id: "nav-expenrise"
                },
                {
                    name: "THE ARTIST",
                    id: "nav-artist"
                },
                {
                    name: "LOCATIONS",
                    id: "nav-place"
                },
                {
                    name: "OUR DANDELION",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "HOW TO SUPPORT",
                    id: "nav-supporters"
                },
                {
                    name: "CONTACT US",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "<i>DANDELION</i> is an art that connects with the world. \n\nBlow a breath upon <i>DANDELION</i> , and its seeds will drift to another <i>DANDELION</i> in a different location, and produce a flower there.\n\nThe flowers we send gather at each location, and eventually become a garden.\n\n\"May there be peace.\" \"May this world become a better place.\"\nSend your prayer on a dandelion seed,\nand let your flower bloom in the world.",
            top_desc_pc: "<i>DANDELION</i> is an art that connects with the world. \n\nBlow a breath upon <i>DANDELION</i> , and its seeds will drift to another <i>DANDELION</i> in a different location, and produce a flower there.\n\nThe flowers we send gather at each location, and eventually become a garden.\n\n\"May there be peace.\" \"May this world become a better place.\"\nSend your prayer on a dandelion seed,\nand let your flower bloom in the world.",
            msg: {
                msg_title: "THE MESSAGE",
                msg_desc_mb: "Our world has changed in so many ways since the beginning of 2020.I wonder about the changes that might occur in the way we connect with the world and with one another.\n\nWith modern devices, everyone is able to communicate and share their feelings with the world. Though we find ourselves constantly making verbal assertions of our own views, I believe there is also a way for people to connect through kind prayers for peacefulness and the wellbeing of each other.\n\n<i>DANDELION</i> is an art that connects people around the world with a very simple gesture. I am fond of this piece, as it embodies the simplicity of making a wish on a dandelion: a childhood memory we can all relate to, as well as its scale of being able to immediately produce flowers in multiple locations around the world.\n\nFlowers need no words. They are completely impartial. Their seeds fly to new places and bloom there. I hope we can go beyond the constraints of race, nationality, or belief, to connect with one another through art and plant flowers of peace throughout the world.",
                msg_desc_pc: "Our world has changed in so many ways since the beginning of 2020.I wonder about the changes that might occur in the way we connect with the world and with one another.\n\nWith modern devices, everyone is able to communicate and share their feelings with the world. Though we find ourselves constantly making verbal assertions of our own views, I believe there is also a way for people to connect through kind prayers for peacefulness and the wellbeing of each other.\n\n<i>DANDELION</i> is an art that connects people around the world with a very simple gesture. I am fond of this piece, as it embodies the simplicity of making a wish on a dandelion: a childhood memory we can all relate to, as well as its scale of being able to immediately produce flowers in multiple locations around the world.\n\nFlowers need no words. They are completely impartial. Their seeds fly to new places and bloom there. I hope we can go beyond the constraints of race, nationality, or belief, to connect with one another through art and plant flowers of peace throughout the world.",

                msg_foot: "RYOTARO MURAMATSU / NAKED"
            },
            art: {
                title1: "THE ARTIST",
                title2: "Ryotaro Muramatsu / NAKED",
                title3: "ARTIST",
                desc1: "Since founding the creative company NAKED Inc. in 1997, the Tokyo based artist has led projects in various fields such as film, television, music videos, advertisements, and spatial presentation.",
                desc2: "Since founding the creative company NAKED Inc. in 1997, the Tokyo based artist has led projects in various fields such as film, television, music videos, advertisements, and spatial presentation. The films he directed have received 48 nominations and awards at film festivals around the world. In recent years he has produced immersive art events including FLOWERS BY NAKED and TOKYO ART CITY BY NAKED, along with events, installations, and live performances in collaboration with leaders of traditional Japanese culture. While teaching as visiting professor at Osaka University of Arts, he also leads local revitalization events and cultural programs in communities around Japan, starting with Achi Village, Nagano where he is branding director. In 2018, he started creating works as a solo artist and since has presented his art both in Japan and overseas. In 2019, he participated in the exhibition DIVERSITY FOR PEACE! held by Karuizawa New Art Museum in Venice, Italy, and at the SUZHOU DESIGN WEEK in Suzhou, China. In Hong Kong, he presented his first overseas solo exhibition 002 at HQUEENS's Hong Kong Whitestone Gallery, and created an immersive experience at Christie's Autumn Auctions 2019 client dinner. In 2020, he launched an international art initiative DANDELION PROJECT that aims to unite people’s prayers for world peace by “planting” interconnected dandelion sculptures in locations around the world.",
            },
            experrience: {
                text_title1: 'EXPERIENCE',
                text_title2_mb: "SEND THE WORLD YOUR VERY OWN DANDELION SEED!",
                text_title2_pc: "SEND THE WORLD YOUR VERY OWN DANDELION SEED!",
                text_btn: 'EXPERIENCE\nDANDELION',
                text_link: 'SUPPORT',
                text_desc: "SUPPORT THIS PROJECT TO PLANT DANDELIONS AROUND THE WORLD",
            },
            result: {
                text_title1_mb: "OUR DANDELION",
                text_title1_pc: "OUR DANDELION",
                text_title2: "FRIENDS OF\nDANDELION PROJECT",
                text_desc: "THE SEEDS WE SEND WILL GATHER HERE AND BECOME PART OF AN EVER-GROWING VIRTUAL DANDELION.",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "LOCATIONS",
                desc_mb: "",
                desc_pc: ""
            },
            ctr: {
                title1: "Cooperating in the \nDANDELION PROJECT",
                title2: "",
                desc1_mb: "The DANDELION PROJECT aims to \"plant\" the\n<i>DANDELION</i> artwork in locations around the world to\npromote messages of peace. With the donations from\nour supporters, we are able to expand our activities to\nmake flowers bloom around the world.",
                desc1_pc: "The DANDELION PROJECT aims to \"plant\" the\n<i>DANDELION</i> artwork in locations around the world to\npromote messages of peace. With the donations from\nour supporters, we are able to expand our activities to\nmake flowers bloom around the world.",
                desc2: "Select the amount you wish to donate to the project,\nand click the \"Support\" button below.",
                btn1: "SUPPORT",
                btn2: "",
                input_tips: "Please enter the amount of money.",
                price_type: "JP¥",
                safari_tips1: "*For those using the Safari browser\n please",
                safari_tips2: " see the additional cautionary notes ",
                safari_tips3: "here.",
                safari_setting_tips: "If you are using Safari, please check the following settings. \nSettings> Safari> Block Pop-ups> OFF\nPlease set it.",
                min_money_tips: "*The donation amount can be entered in ¥50 increments.",
                law_tips: 'Guide for Specified Commercial Transactions Act',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "SUPPORTERS",
            contactTitle: "CONTACT US",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: 'Connecting Prayers for Peace with Breath/Bless Project',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '',

            // ページの詳細
            description: 'This is an artwork that keeps growing as it connects locations and people around the world.' +
                '\r\n' +
                '\r\n' +
                'When you blow your breath on a <i>Dandelion</i>,' +
                '\r\n' +
                'the fluff will float to a faraway city and produce a new, beautiful flower there.' +
                '\r\n' +
                '\r\n' +
                ' A “<i>Breath</i>” sends prayers from one place to another, ' +
                '\r\n' +
                'filling the world with “<i>Blessings</i>,” or prayers for peace.' +
                '\r\n' +
                '\r\n' +
                'Real locations and the virtual world synchronize,' +
                '\r\n' +
                'as the network itself, which connects the many prayers, becomes the artwork.',
            description_sp: 'This is an artwork that keeps growing as it connects' +
                '\r\n' +
                'locations and people around the world.' +
                '\r\n' +
                '\r\n' +
                'When you blow your breath on a <i>Dandelion</i>,' +
                '\r\n' +
                'the fluff will float to a faraway city and produce a new,' +
                '\r\n' +
                'beautiful flower there.' +
                '\r\n' +
                '\r\n' +
                ' A “<i>Breath</i>” sends prayers from one place to another, ' +
                '\r\n' +
                'filling the world with “<i>Blessings</i>,” or prayers for peace.' +
                '\r\n' +
                '\r\n' +
                'Real locations and the virtual world synchronize,' +
                '\r\n' +
                'as the network itself, which connects the many prayers,' +
                '\r\n' +
                'becomes the artwork.',


            subtitle2: 'Let your own flower of prayers bloom in the world',

            textcontents_qr: 'If you are nearby a <i>Dandelion</i>',
            textcontents_qr_button: 'INTERACTIVE CODE',

            textcontents_ol: 'If you are joining in online',
            textcontents_ol_button: 'FIND YOUR FLOWER',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_en.jpg',
            // send_modal_image_sp: './Images/mask_image.jpg',
            // send_modal_image_tb: './Images/mask_image.jpg',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu /NAKED, INC. ',
                description: 'Since founding the creative company NAKED, INC. in 1997, the Tokyo based artist has led projects in various fields such as film, television, music videos, advertisements, and spatial presentation. The films he directed have received 48 nominations and awards at film festivals around the world. In recent years he has produced immersive art events including FLOWERS BY NAKED and TOKYO ART CITY BY NAKED, along with events, installations, and live performances in collaboration with leaders of traditional Japanese culture. While teaching as visiting professor at Osaka University of Arts, he also leads local revitalization events and cultural programs in communities around Japan, starting with Achi Village, Nagano where he is branding director. In 2018, he started creating works as a solo artist and since has presented his art both in Japan and overseas. In 2019, he participated in the exhibition "DIVERSITY FOR PEACE!" held by Karuizawa New Art Museum in Venice, Italy, and at the SUZHOU DESIGN WEEK in Suzhou, China. In Hong Kong, he presented his first overseas solo exhibition 002 at HQUEENS\'s Hong Kong Whitestone Gallery, and created an immersive experience at Christie\'s Autumn Auctions 2019 client dinner.',
                message: 'Our world has changed in so many ways since the beginning of 2020, and difficult times continue. People all over the globe, from every background, wish fervently for a better world. It is my hope that our shared adversity will not divide us but will, instead, bring us closer together.  ' +
                    '\r\n' +
                    '\r\n' +
                    '<i>Dandelion</i> is an interactive artwork that evokes the feeling one gets from making a wish on a dandelion. When the viewer blows a breath on the <i>Dandelion</i> installation, the fluff floats away, eventually landing on the ground and producing a new flower. I am fond of this digitally augmented piece, as it brings back the pure, simple childhood feeling we all remember and can relate to beyond the constraints of race, nationality, or belief.' +
                    '\r\n' +
                    '\r\n' +
                    'This artwork is alive.' +
                    '\r\n' +
                    'As more <i>Dandelion</i> installations are set up around the world and more people participate, their many prayers will connect within this large and ever-expanding artwork. In past years, I have created works that integrate virtual and real, digital and analog; what I wish to offer the world today is an artwork that transcends barriers to unite people’s hearts.' +
                    '\r\n' +
                    '\r\n' +
                    'Flowers need no words. They are completely impartial.' +
                    '\r\n' +
                    'Their seeds fly to new places and bloom there.' +
                    '\r\n' +
                    'Through this art, I hope to spread this spirit, to plant flowers of peace throughout the world.' +
                    '\r\n' +
                    '\r\n' +
                    '<p style="font-size: 1.0rem;">Ryotaro Muramatsu / NAKED</p>',
                message_sp: '<font size="4">"</font>Our world has changed in so many ways since the beginning of 2020, and difficult times continue. People all over the globe, from every background, wish fervently for a better world. It is my hope that our shared adversity will not divide us but will, instead, bring us closer together.  ' +
                    '\r\n' +
                    '\r\n' +
                    '<i>Dandelion</i> is an interactive artwork that evokes the feeling one gets from making a wish on a dandelion. When the viewer blows a breath on the <i>Dandelion</i> installation, the fluff floats away, eventually landing on the ground and producing a new flower. I am fond of this digitally augmented piece, as it brings back the pure, simple childhood feeling we all remember and can relate to beyond the constraints of race, nationality, or belief.' +
                    '\r\n' +
                    '\r\n' +
                    'This artwork is alive.' +
                    '\r\n' +
                    'As more <i>Dandelion</i> installations are set up around the world and more people participate, their many prayers will connect within this large and ever-expanding artwork. In past years, I have created works that integrate virtual and real, digital and analog; what I wish to offer the world today is an artwork that transcends barriers to unite people’s hearts.' +
                    '\r\n' +
                    '\r\n' +
                    'Flowers need no words. They are completely impartial.' +
                    '\r\n' +
                    'Their seeds fly to new places and bloom there.' +
                    '\r\n' +
                    'Through this art, I hope to spread this spirit, to plant flowers of peace throughout the world.<font size="4">"</font>'
            },

            // 寄付のお願い
            contribution: {
                title_pc: 'Join us to plant <i>Dandelions</i> around the world',
                title_sp: 'Join us to plant <i>Dandelions</i>' +
                    '\r\n' +
                    'around the world',
                message: '<i>DANDELION PROJECT</i> asks for your support to “plant”' +
                    '\r\n' +
                    'interactive <i>Dandelion</i> installations around the world.' +
                    '\r\n' +
                    'Join us to spread this symbol of prayers for peace,' +
                    '\r\n' +
                    'and fill the world with flowers.' +
                    '\r\n' +
                    '\r\n',
                message_sp: '<i>DANDELION PROJECT</i> asks for your support to “plant”' +
                    '\r\n' +
                    'interactive <i>Dandelion</i> installations around the world.' +
                    '\r\n' +
                    'Join us to spread this symbol of prayers for peace,' +
                    '\r\n' +
                    'and fill the world with flowers.' +
                    '\r\n' +
                    '\r\n',
                button: 'Fund this artwork',
                cloudfunding_abount: '',
                cloudfunding_description: 'There are many other ways to support this project.',
                cloudfunding_description_sp: 'There are many other ways to support this project.',
                cloudfunding_button: 'Learn more',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            place: [{
                    name_mb1: 'JAPAN・HIROSHIMA',
                    name_mb2: 'ORIZURU TOWER',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: 'JAPAN・HIROSHIMA / ORIZURU TOWER',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・OSAKA',
                    name_mb2: 'VS. at GRAND GREEN OSAKA',
                    image_mb: './Images/Place/mb/s00177.png',
                    name: 'JAPAN・OSAKA / VS. at GRAND GREEN OSAKA',
                    time: '2026.4.17 ー 2026.6.15',
                    image: './Images/Place/s00177.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: 'Taiwan・Taipei',
                    name_mb2: 'Songyan Cultural and Creative Park',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: 'Taiwan・Taipei / Songyan Cultural and Creative Park',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'Warehouse TERRADA',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: 'JAPAN・TOKYO / Warehouse TERRADA',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: 'JAPAN・HYOGO',
                    name_mb2: 'Himeji Castle Sannomaru Hiroba (Sannomaru Square)',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: 'JAPAN・HYOGO / Himeji Castle Sannomaru Hiroba (Sannomaru Square)',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: 'JAPAN・KYOTO',
                    name_mb2: 'YASAKA SHRINE',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: 'JAPAN・KYOTO / YASAKA SHRINE',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・KYOTO',
                    name_mb2: 'FUSHIMI INARI-TAISHA SHRINE',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: 'JAPAN・KYOTO / FUSHIMI INARI-TAISHA SHRINE',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・HYOGO',
                    name_mb2: 'ROKKO ALPINE BOTANICAL GARDEN',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: 'JAPAN・HYOGO / ROKKO ALPINE BOTANICAL GARDEN',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: 'JAPAN・KYOTO',
                    name_mb2: 'NIJO-JO CASTLE',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: 'JAPAN・KYOTO / NIJO-JO CASTLE',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: 'CHINA・BEIJING',
                    name_mb2: 'Meet You Museum',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: 'CHINA・BEIJING / Meet You Museum',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Hiyoshi Taisha Shrine（Shirayamahime Shrine）',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: 'JAPON・SHIGA / Hiyoshi Taisha Shrine（Shirayamahime Shrine）',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・ISHIKAWA',
                    name_mb2: 'Natadera Temple',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: 'JAPAN・ISHIKAWA / Natadera Temple',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Mt.Hiei Enryakuji Temple Shaka-do Hall',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: 'JAPON・SHIGA / Mt.Hiei Enryakuji Temple Shaka-do Hall',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'The City of Hikone is in Shiga Prefecture',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: 'JAPAN・SHIGA / The City of Hikone is in Shiga Prefecture',
                    time: '2024.3.22 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                // {
                //     name_mb1: 'JAPAN・OSAKA',
                //     name_mb2: 'Abstract Harkus Observatory \'HARUKAS 300\'',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: 'JAPAN・OSAKA / Abstract Harkus Observatory \'HARUKAS 300\'',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: 'TICKET REQUIRED',
                //     url_msg: 'VIEW MORE',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // },
                {
                    name_mb1: 'JAPAN・OSAKA',
                    name_mb2: 'Expo’70 Commemorative Park',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: 'JAPAN・OSAKA / Expo’70 Commemorative Park',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'HIKONE CASTLE',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: 'JAPAN・SHIGA / HIKONE CASTLE',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'NIJO-JO CASTLE',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: 'JAPAN・KYOTO / NIJO-JO CASTLE',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'W OSAKA',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: 'JAPAN・OSAKA / W OSAKA',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KYOTO NATIONAL MUSEUM',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: 'JAPAN・KYOTO / KYOTO NATIONAL MUSEUM',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'NINNA-JI TEMPLE',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: 'JAPAN・KYOTO / NINNA-JI TEMPLE',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'ACE HOTEL KYOTO',
                    image_mb: './Images/Place/mb/s00134.png',
                    name: 'JAPAN・KYOTO / ACE HOTEL KYOTO',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KARAMON GATE of NISHI HONGWANJI TEMPLE',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: 'JAPAN・KYOTO / KARAMON GATE of NISHI HONGWANJI TEMPLE',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'HEIAN JINGU SHRINE',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: 'JAPAN・KYOTO / HEIAN JINGU SHRINE',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KITANO TENMANGU SHRINE',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: 'JAPAN・KYOTO / KITANO TENMANGU SHRINE',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPAN・UJI',
                    name_mb2: 'UJI CITY',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: 'JAPAN・UJI / UJI CITY',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'HIKONE CASTLE',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: 'JAPAN・SHIGA / HIKONE CASTLE',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'SHIGA-IN MONSEKI TEMPLE',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: 'JAPAN・SHIGA / SHIGA-IN MONSEKI TEMPLE',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: 'OPEN TO THE PUBLIC（Fri,Sat,Sun,Japanese National Holidays）・TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'SAUDI ARABIA・RIYADH',
                    name_mb2: 'AL MURABAA',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: 'SAUDI ARABIA・RIYADH / AL MURABAA',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'NIJO-JO CASTLE',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: 'JAPAN・KYOTO / NIJO-JO CASTLE',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KAMIGAMO SHRINE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: 'JAPAN・KYOTO / KAMIGAMO SHRINE',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPAN・OSAKA',
                    name_mb2: 'UMEKITA SOTONIWA SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: 'JAPAN・OSAKA / UMEKITA SOTONIWA SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'OLD MITSUI FAMILY SHIMOGAMO VILLA',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: 'JAPAN・KYOTO / OLD MITSUI FAMILY SHIMOGAMO VILLA',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KYOTO CITY HALL',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: 'JAPAN・KYOTO / KYOTO CITY HALL',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'ENRYAKUJI TEMPLE',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: 'JAPAN・SHIGA / ENRYAKUJI TEMPLE',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'HEIAN JINGU SHRINE',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: 'JAPAN・KYOTO / HEIAN JINGU SHRINE',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'ARASHIYAMA',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: 'JAPAN・KYOTO / ARASHIYAMA',
                    time: '2021.12.10 ー 2021.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KOSHOJI',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: 'JAPAN・KYOTO / KOSHOJI',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPAN・SHIGA',
                    name_mb2: 'HIKONE CASTLE',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: 'JAPAN・SHIGA / HIKONE CASTLE',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPAN・KO-CHI',
                    name_mb2: 'KO-CHI CASTLE',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: 'JAPAN・KO-CHI / KO-CHI CASTLE',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: 'JAPAN・KUMAMOTO',
                    name_mb2: 'KUMAMOTO CASTLE',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: 'JAPAN・KUMAMOTO / KUMAMOTO CASTLE',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KIYOMIZU-DERA TEMPLE',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: 'JAPAN・KYOTO / KIYOMIZU-DERA TEMPLE',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: 'CLOSED TO PUBLIC',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KITANO TENMANGU SHRINE',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: 'JAPAN・KYOTO / KITANO TENMANGU SHRINE',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                },

                {
                    name_mb1: 'FRANCE・PARIS',
                    name_mb2: 'SAMARITAINE',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: 'FRANCE・PARIS / SAMARITAINE',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''
                },

                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'NINNA-JI TEMPLE',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: 'JAPAN・KYOTO / NINNA-JI TEMPLE',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: 'CLOSED TO PUBLIC',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'KAMIGAMO-SHRINE',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: 'JAPAN・KYOTO / KAMIGAMO-SHRINE',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: 'CLOSED TO PUBLIC',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/kyoto/'


                },
                {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'AKASAKA TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: 'JAPAN・TOKYO / AKASAKA TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: 'FREE EXHIBITION',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: 'JAPAN・SAGA',
                    name_mb2: 'SAGA PREFECTURAL OFFICE OBSERVATION HALL',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: 'JAPAN・SAGA / SAGA PREFECTURAL OFFICE OBSERVATION HALL',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: 'TICKET REQUIRED',
                    url_msg: 'VIEW MORE',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: 'JAPAN・SAITAMA',
                    name_mb2: 'MOOMINVALLEY PARK',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "JAPAN・SAITAMA / MOOMINVALLEY PARK",
                    time: "2020.11.21 － 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'MIYASHITA PARK',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "JAPAN・TOKYO / MIYASHITA PARK",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'SINGAPORE',
                    name_mb2: 'GARDENS BY THE BAY',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "SINGAPORE / GARDENS BY THE BAY",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'TOKYO TOWER',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "JAPAN・TOKYO / TOKYO TOWER",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}